import React from 'react'

import type { TitleProps } from './types'

const Title = ({ children, className = '' }: TitleProps) => (
  <h2 className={`title ${className}`}>{children}</h2>
)

export default Title
